export default "__VITE_ASSET__f5da655f__$_?nuxt_component=async__"